import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { SETTINGS_URL } from "@/settings/config/settings-urls";

const SettingsOverview = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(SETTINGS_URL.ORGANIZATION, { replace: true });
  }, [navigate]);

  return null;
};

export default SettingsOverview;
